const Paragraph = ({ label }) => {
    const mainClass = "help-paragraph";
	return <div className={mainClass} dangerouslySetInnerHTML={{ __html: label }} />
};

export default Paragraph;
